/* eslint-disable max-len */
export default {
  getUserSignature: (state) => state.userSignature,
  getSignature: (state) => (reportName, role) => state.userSignatures?.filter((u) => u.reportName === reportName && u.role === role) ?? [],
};
